var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("Page", {
        attrs: { title: _vm.pageTitle },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function() {
              return [
                _c("div", { staticClass: "my-2" }, [
                  _c(
                    "div",
                    {},
                    [
                      _c(
                        "h3",
                        {
                          staticClass:
                            "text-base leading-6 font-medium text-gray-900 my-2"
                        },
                        [_vm._v(" Selete Date ")]
                      ),
                      _c("DateRangePicker", {
                        attrs: { opens: "right", ranges: _vm.ranges },
                        on: { update: _vm.dateSelected },
                        model: {
                          value: _vm.currentConfig,
                          callback: function($$v) {
                            _vm.currentConfig = $$v
                          },
                          expression: "currentConfig"
                        }
                      }),
                      _vm.isLoading ? _c("div", [_c("Spinner")], 1) : _vm._e(),
                      _c(
                        "h3",
                        {
                          staticClass:
                            "text-lg leading-6 font-medium text-gray-900 mt-4"
                        },
                        [_vm._v(" " + _vm._s(_vm.dateDiff) + " ")]
                      ),
                      _c(
                        "h3",
                        {
                          staticClass:
                            "text-lg leading-6 font-medium text-gray-900 mt-5"
                        },
                        [_vm._v(" Abandoned carts ")]
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "mt-5 grid grid-cols-1 gap-5 sm:grid-cols-3"
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "bg-white overflow-hidden shadow rounded-lg"
                            },
                            [
                              _c("div", { staticClass: "px-4 py-5 sm:p-6" }, [
                                _c("dl", [
                                  _c(
                                    "dt",
                                    {
                                      staticClass:
                                        "text-sm leading-5 font-medium text-gray-500 "
                                    },
                                    [_vm._v(" Messages sent ")]
                                  ),
                                  _c(
                                    "dd",
                                    {
                                      staticClass:
                                        "mt-1 text-3xl leading-9 font-semibold text-gray-900"
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.checkoutReport.totalMessagesSent
                                          ) +
                                          " "
                                      )
                                    ]
                                  )
                                ])
                              ])
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticClass:
                                "bg-white overflow-hidden shadow rounded-lg"
                            },
                            [
                              _c("div", { staticClass: "px-4 py-5 sm:p-6" }, [
                                _c("dl", [
                                  _c(
                                    "dt",
                                    {
                                      staticClass:
                                        "text-sm leading-5 font-medium text-gray-500 "
                                    },
                                    [_vm._v(" Carts recovered ")]
                                  ),
                                  _c(
                                    "dd",
                                    {
                                      staticClass:
                                        "mt-1 text-3xl leading-9 font-semibold text-gray-900"
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.checkoutReport.cartsRecovered
                                          ) +
                                          " "
                                      )
                                    ]
                                  )
                                ])
                              ])
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticClass:
                                "bg-white overflow-hidden shadow rounded-lg"
                            },
                            [
                              _c("div", { staticClass: "px-4 py-5 sm:p-6" }, [
                                _c("dl", [
                                  _c(
                                    "dt",
                                    {
                                      staticClass:
                                        "text-sm leading-5 font-medium text-gray-500 "
                                    },
                                    [_vm._v(" Cart value recovered ")]
                                  ),
                                  _c(
                                    "dd",
                                    {
                                      staticClass:
                                        "mt-1 text-3xl leading-9 font-semibold text-gray-900"
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.checkoutReport
                                              .cartsRecoveredValue
                                          ) +
                                          " "
                                      )
                                    ]
                                  )
                                ])
                              ])
                            ]
                          )
                        ]
                      ),
                      _c(
                        "h3",
                        {
                          staticClass:
                            "text-lg leading-6 font-medium text-gray-900 mt-5"
                        },
                        [_vm._v(" Chat & share ")]
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "mt-5 grid grid-cols-1 gap-5 sm:grid-cols-3"
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "bg-white overflow-hidden shadow rounded-lg"
                            },
                            [
                              _c("div", { staticClass: "px-4 py-5 sm:p-6" }, [
                                _c("dl", [
                                  _c(
                                    "dt",
                                    {
                                      staticClass:
                                        "text-sm leading-5 font-medium text-gray-500 "
                                    },
                                    [_vm._v(" Chat clicked ")]
                                  ),
                                  _c(
                                    "dd",
                                    {
                                      staticClass:
                                        "mt-1 text-3xl leading-9 font-semibold text-gray-900"
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.chatReport.chatClicks) +
                                          " "
                                      )
                                    ]
                                  )
                                ])
                              ])
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticClass:
                                "bg-white overflow-hidden shadow rounded-lg"
                            },
                            [
                              _c("div", { staticClass: "px-4 py-5 sm:p-6" }, [
                                _c("dl", [
                                  _c(
                                    "dt",
                                    {
                                      staticClass:
                                        "text-sm leading-5 font-medium text-gray-500 "
                                    },
                                    [_vm._v(" Share Clicked ")]
                                  ),
                                  _c(
                                    "dd",
                                    {
                                      staticClass:
                                        "mt-1 text-3xl leading-9 font-semibold text-gray-900"
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.chatReport.shareClicks) +
                                          " "
                                      )
                                    ]
                                  )
                                ])
                              ])
                            ]
                          )
                        ]
                      ),
                      _c("div", { staticClass: "Polaris-LegacyCard mt-4" }, [
                        _c("div", { staticClass: "Polaris-MediaCard" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "Polaris-MediaCard__MediaContainer Polaris-MediaCard--sizeSmall"
                            },
                            [
                              _c("img", {
                                staticStyle: {
                                  "object-fit": "cover",
                                  "object-position": "center"
                                },
                                attrs: {
                                  alt: "",
                                  width: "100%",
                                  height: "100%",
                                  src:
                                    "https://cdn.shopify.com/app-store/listing_images/8fc5f6d4d41f33cfcf0ebc61d01b572a/icon/CN2aot70lu8CEAE=.png"
                                }
                              })
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticClass:
                                "Polaris-MediaCard__InfoContainer Polaris-MediaCard--sizeSmall"
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "Polaris-LegacyCard__Section" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "Polaris-LegacyStack Polaris-LegacyStack--vertical Polaris-LegacyStack--spacingTight"
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "Polaris-LegacyStack__Item"
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "Polaris-MediaCard__Heading"
                                            },
                                            [
                                              _c(
                                                "h2",
                                                {
                                                  staticClass:
                                                    "Polaris-Text--root Polaris-Text--headingMd"
                                                },
                                                [
                                                  _vm._v(
                                                    " Automated abandoned cart recovery "
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "Polaris-LegacyStack__Item"
                                        },
                                        [
                                          _c("p", [
                                            _vm._v(
                                              " Send reminders to abandoned checkouts on WhatsApp to convert more orders "
                                            )
                                          ])
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "Polaris-LegacyStack__Item"
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "Polaris-MediaCard__ActionContainer"
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "Polaris-ButtonGroup"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "Polaris-ButtonGroup__Item"
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "Polaris-MediaCard__PrimaryAction"
                                                        },
                                                        [
                                                          _c(
                                                            "button",
                                                            {
                                                              staticClass:
                                                                "Polaris-Button",
                                                              attrs: {
                                                                type: "button"
                                                              },
                                                              on: {
                                                                click:
                                                                  _vm.gotoAutomation
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "Polaris-Button__Content"
                                                                },
                                                                [
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "Polaris-Button__Text"
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "Setup Automation"
                                                                      )
                                                                    ]
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          )
                        ])
                      ]),
                      _c("OnboardingChecklist", { staticClass: "my-4" })
                    ],
                    1
                  )
                ])
              ]
            },
            proxy: true
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }